/**
 * The client-error reporting contract, kept in its own module (and its own package subpath) because
 * the web entry chunk must not pull in a whole domain entry to read four numbers: the former root barrel
 * measured 5.9 kB -> 484 kB on the eagerly loaded bundle. No domain entry re-exports this file; server and
 * client both import it from '@towerpower/shared/client-error-reporting'.
 */
export const CLIENT_ERROR_KINDS = ['error', 'unhandledrejection', 'bootstrap'];
export const CLIENT_ERROR_MESSAGE_MAX_LENGTH = 500;
export const CLIENT_ERROR_STACK_MAX_LENGTH = 4000;
export const CLIENT_ERROR_URL_MAX_LENGTH = 200;
export const BUILD_ID_MAX_LENGTH = 64;
export const USER_AGENT_MAX_LENGTH = 300;
export const BUG_REPORT_MESSAGE_MAX_LENGTH = 2000;
export const BUG_REPORT_SCENE_MAX_LENGTH = 64;
/** "WIDTHxHEIGHT" in CSS pixels, as the bug-report form reads it off the viewport. */
export const VIEWPORT_PATTERN = /^\d{1,5}x\d{1,5}$/;
